import { Outlet } from "react-router-dom";

export default function StoreManagementOutlet() {
  return <Outlet />;
}
